import { FormAdapter } from "hooks/useForm";
import { ECommerceOnboardingFilableResource } from "consts/ecommerce";
import { WebRoutes } from "consts/enpoints/web";
import type { HighRiskMerchant as HighRiskMerchantType } from "features/ecommerce/types";
import { HighRiskMerchant as HighRiskMerchantApi } from "features/ecommerce/api";
import { HighRiskMerchant } from "ui/forms/ECommerce";
import { useOnboardingFileUpload, useOnboardingForm, useOnboardingStepData } from "ui/organizms/ECommerce/Onboarding/common";
import { useOnboardingApplication } from "../../hooks";

export const useUploadDocuments = () => {
    const { getApplicationModel } = useOnboardingApplication();

    const { data } = useOnboardingStepData<HighRiskMerchantType.OnboardingUploadDocuments>();

    const uploadFiles = useOnboardingFileUpload();

    const withValues = useOnboardingForm({
        save: HighRiskMerchantApi.putOnboardingsHighRiskUploadDocumentsSteps,
        route: WebRoutes.Onboarding.HighRiskMerchant,
        getApplicationModel
    });

    const formProps: HighRiskMerchant.UploadDocuments.OnboardingUploadDocumentsForm = {
        bootstrapData: {},
        initialValues: HighRiskMerchant.UploadDocuments.getInitialValues(data),
        isBootstrapDataLoading: false,
        onSaveOrCreate: async ({
            certificateOfIncorporationFileKey,
            memorandumAndArticlesFileKey,
            companyAccountBankStatementFileKey,
            companyFinancialStatementFileKey,
            bankReferenceFileKey,
            copyOfLicencesFileKey,
            proofOfDomainOwnershipFileKey,
            passportsOfShareholdersFileKey,
            utilityBillOfShareholdersFileKey,
            officialCompanyDocWithAuthorityFileKey,
            structureChartFileKey
        }, helpers) => {
            try {
                await uploadFiles({
                    resource: ECommerceOnboardingFilableResource.ClientDocumentsSteps
                }, [
                    companyAccountBankStatementFileKey, HighRiskMerchant.UploadDocuments.FormField.CompanyAccountBankStatementFileKey
                ], [
                    certificateOfIncorporationFileKey, HighRiskMerchant.UploadDocuments.FormField.CertificateOfIncorporationFileKey
                ], [
                    memorandumAndArticlesFileKey, HighRiskMerchant.UploadDocuments.FormField.MemorandumAndArticlesFileKey
                ], [
                    companyFinancialStatementFileKey, HighRiskMerchant.UploadDocuments.FormField.CompanyFinancialStatementFileKey
                ], [
                    bankReferenceFileKey, HighRiskMerchant.UploadDocuments.FormField.BankReferenceFileKey
                ], [
                    copyOfLicencesFileKey, HighRiskMerchant.UploadDocuments.FormField.CopyOfLicencesFileKey
                ], [
                    proofOfDomainOwnershipFileKey, HighRiskMerchant.UploadDocuments.FormField.ProofOfDomainOwnershipFileKey
                ], [
                    passportsOfShareholdersFileKey, HighRiskMerchant.UploadDocuments.FormField.PassportsOfShareholdersFileKey
                ], [
                    utilityBillOfShareholdersFileKey, HighRiskMerchant.UploadDocuments.FormField.UtilityBillOfShareholdersFileKey
                ], [
                    officialCompanyDocWithAuthorityFileKey, HighRiskMerchant.UploadDocuments.FormField.OfficialCompanyDocWithAuthorityFileKey
                ], [
                    structureChartFileKey, HighRiskMerchant.UploadDocuments.FormField.StructureChartFileKey
                ]);

                return withValues({}, helpers);
            } catch (failedfileResponse) {
                return FormAdapter.fromResponse(failedfileResponse)
            }
        }
    };

    return {
        ...formProps,
        ...HighRiskMerchant.UploadDocuments.useForm(formProps),
        ...data
    };
};

export default useUploadDocuments;
